import { AMAZON_URL } from "./constants";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-linenborder bg-linen py-12">
    <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-6 text-center sm:px-12 md:flex-row md:text-left lg:px-20">
      <div>
        <p className="font-serif text-lg font-semibold text-espresso">
          Love the Life You Live
        </p>
        <p className="mt-1 text-xs text-sand">
          A gratitude journal by Live Love Laugh Press &amp; Brian K. Gilbert
        </p>
      </div>
      <a
        data-testid="footer-amazon-link"
        href={AMAZON_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm font-medium text-terracotta underline-offset-4 transition-colors hover:text-sienna hover:underline"
      >
        View on Amazon
      </a>
      <p className="max-w-xs text-[11px] leading-relaxed text-sand/80">
        As an Amazon-listed product, purchases, shipping and returns are
        handled securely by Amazon.
      </p>
    </div>
  </footer>
);
